import { render, staticRenderFns } from "./Create-Project.vue?vue&type=template&id=2efc4ff7&scoped=true"
import script from "./Create-Project.vue?vue&type=script&lang=js"
export * from "./Create-Project.vue?vue&type=script&lang=js"
import style0 from "./Create-Project.vue?vue&type=style&index=0&id=2efc4ff7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efc4ff7",
  null
  
)

export default component.exports